import ConsumerSelect from "./consumerSelect.container";

export default ConsumerSelect;
